export default "__VITE_ASSET__FG0gJFs2__"